import { useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { IArtEntity } from "../../../Services/api/arts/arts.interface";
import { DestroyArtsUseCase } from "../../../Usecase/Arts/destroy-arts-usecase";
import { ListArtsUseCase } from "../../../Usecase/Arts/list-arts-usecase";
import { ListOrdersReplacementUseCase } from "../../../Usecase/OrdersReplacement/list-orders-replacement-usecase";
import { IOrderReplacementEntity, IOrdersReplacementListPayload } from "../../../Services/api/orders-replacement/orders-replacement.interface";
import { DestroyOrdersReplacementUseCase } from "../../../Usecase/OrdersReplacement/destroy-orders-replacement-usecase";
import { format, parseISO } from "date-fns";
import { normalizeDateTimeZoneInString, normalizeDateToInputCalendar } from "../../../utils/chronos";

interface IUseListArtsProps {

  
  listOrdersReplacementUseCase: ListOrdersReplacementUseCase
  destroyOrdersReplacementUseCase: DestroyOrdersReplacementUseCase
}
export function useListOrdersReplacement({ listOrdersReplacementUseCase, destroyOrdersReplacementUseCase }: IUseListArtsProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<IOrderReplacementEntity[]>([])
    const [orderToDestroy, setOrderToDestroy] = useState('')
    const [totalRegisters, setTotalRegisters] = useState(1)
    const [currentFilters, setCurrentFilters] = useState<IOrdersReplacementListPayload>({ page: 1 })
   
    const { showToast } =  useToast()

    const listOrdersReplacement = async ({ page: currentPage, searchBy }: IOrdersReplacementListPayload) => {
        
        try {
          setLoading(true)

          // Merge current filters with new search/filter parameters
          const filters = {
            ...currentFilters,
            page: currentPage || currentFilters.page,
            searchBy: searchBy || currentFilters.searchBy
          }
          
          // Update current filters
          setCurrentFilters(filters)
          
          const listResult = await listOrdersReplacementUseCase.handle(filters);

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()
     
        
            setData(list?.data || [])
            setTotalRegisters(list?.total || 0)
        

    
         setPage(currentPage)
        } catch (error) {
          console.log("error listArts function: ", error)
        } finally {
          setLoading(false);
        }
      };

    const list = useMemo(() => {
        const rows = data?.map(product => {
          const date = normalizeDateTimeZoneInString(String(product.dueDate))
                   
          
            return {
                ...product,
                createdAt: format(parseISO(product.createdAt), 'dd/MM/yyyy'),
                dueDate: product?.dueDate ? normalizeDateToInputCalendar(date) : 'Não informado'
            }
        })

        return rows
    }, [data])

    const handleDestroyOrderReplacement = async () => {
        
      try {
        setLoading(true)
        
        const destroyResult = await destroyOrdersReplacementUseCase.handle(orderToDestroy);

        if (destroyResult.isFailure) {
     
          showToast(String(destroyResult?.error?.error), 'error');
          return;
        }

        setOrderToDestroy('')
        showToast('Removido com sucesso.', 'success');

       await listOrdersReplacement({ page: 1})
      } catch (error) {
        console.log("error destroyArts function: ", error)
      } finally {
        setLoading(false);
      }
    };

      

    return {
        loading,
        listOrdersReplacement,
        list,
        data,
        setOrderToDestroy,
        orderToDestroy,
        handleDestroyOrderReplacement,
        totalRegisters,
        currentFilters,
        setCurrentFilters
    }
}